export default __webpack_public_path__ + "static/media/hoty.0339e460.png";